import React from "react";
import { EuiCallOut, EuiSpacer } from "@elastic/eui";
/**
 *
 *  Errors can be array or object
 */

interface ErrorsListProps {
  errors?: string[] | { [key: string]: string };
  title?: string;
}

const ErrorsList: React.FunctionComponent<ErrorsListProps> = ({
  errors,
  title = "Please address the highlighted errors.",
}) => {
  return !errors || Object.values(errors).length === 0 ? null : (
    <>
      {Object.values(errors).filter((v) => v).length > 0 && (
        <>
          <EuiCallOut color="danger" iconType="warning" size="s" title={title}>
            {Object.values(errors).map((error, index) => (
              <div key={`for_error_${index}`}>{error}</div>
            ))}
          </EuiCallOut>
          <EuiSpacer />
        </>
      )}
    </>
  );
};

export default ErrorsList;
